import { useDispatch } from 'react-redux'
import {
  setDisabledPriority,
  setEnablePriority
} from '../redux/actions/otInboundAction'

export const usePriority = () => {
  const dispatch = useDispatch()

  const enablePriority = () => dispatch(setEnablePriority())
  const disabledPriority = () => dispatch(setDisabledPriority())

  return { enablePriority, disabledPriority }
}
